export enum BroadcastResolution {
  Res1080p30fps = '1080p30fps',
  Res1080p60fps = '1080p60fps',
  Res720p30fps = '720p30fps',
  Res720p60fps = '720p60fps',
}
